// eslint-disable-next-line import/no-unused-modules
export { default } from "./ChatInput";
